<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <div class="row mb-4">
        <div class="col-lg-8 col-md-12 col-sm-12 ml-auto mr-auto">
          <label class="mr-4 h6">Welcome Letter Audience</label>
          <el-select
            class="select-default2"
            name="audience"
            placeholder=""
            v-model="letterindex"
          >
            <el-option
              v-for="option in selectorOptions"
              :key="option.value"
              class="select-default2"
              :label="option.text"
              :value="option.value"
            />
          </el-select>
        </div>
      </div>
      <ckeditor
        :editor="editor"
        v-model="letter.Letter"
        :config="editorConfig"
      />
      <button
        type="submit"
        class="btn btn-primary"
        @click="submitForm"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import welcomeLetterApi from '@/services/api/welcomeletter'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'WelcomeLetterEdit',
  components: {
    oops,
    ckeditor: CKEditor.component
  },
  data: function () {
    return {
      letters: null,
      letterindex: 0,
      editorConfig: {},
      editor: ClassicEditor,
      loading: true,
      errormessage: null,
      selectorOptions: []
    }
  },
  computed: {
    letter: function () {
      return this.letters[this.letterindex]
    }
  },
  mounted () {
    welcomeLetterApi
      .list(this.$root.courseKey)
      .then(response => {
        this.letters = response
        let i
        for (i = 0; i < response.length; i++) {
          const j = { value: i, text: response[i].CourseScouterType }
          this.selectorOptions.push(j)
        }
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    submitForm: function () {
      welcomeLetterApi.update(this.$root.courseKey, this.letters).then(x => {
        this.$notify({
          message: 'Welcome Letter Updated.',
          icon: 'nc-icon nc-satisfied',
          type: 'success',
          horizontalAlign: 'center',
          timeout: 2000
        })
      })
    }
  }
}
</script>
